import React from "react";

interface DashboardCountBoxProps {
    variant: "pending" | "confirmed";
    count: number;
}

export let DashboardCountBox = function (props: DashboardCountBoxProps) {
    if (props.count <= 0) {
        return null;
    }
    return (
        <div className={`dashboard-count-box ${props.variant}`}>
            <div className="dashboard-count-box-number">{props.count}</div>
        </div>
    );
};
